import React from 'react';
import noDataImg from '../assets/images/nodata.jpg'

const NoDataState = () => {
  return(
    <div className='nodata'>
      <img src={noDataImg} alt='' className='mb-3' />
      <p>No bookings have been created yet</p>
    </div>
  );
}

export default NoDataState;